/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React from 'react';

import { UnifiedCollectionType } from 'client-code/previews';

import { TIVO_SERVICES } from '../../../config';
import { ImageAssetsService } from '../../../core/infrastructure';
import { ServicesClientImpl } from '../../../core/interactors';
import { TUnifiedCollectionPreview } from '../../../core/types';
import { PreviewComponentAssets } from '../../../core/usecases';
import { ContentDescription, ContentTitle, ShowcaseBanner } from '../ui-kit';
import type { TInfoCardContentUtil } from './InfoCardProps';

export const getTeamAndLeagueInfoCardContent: TInfoCardContentUtil = (metadata) => {
    const oPreviewAssets = new PreviewComponentAssets();
    const {
        unifiedCollectionType,
        title = '',
        description = oPreviewAssets.getStringAssestById(
            PreviewComponentAssets.StringAssets.DESCRIPTION_NOT_AVAILABLE,
        ),
        postfixTitle = '',
        unifiedCollectionId = '',
    } = metadata as TUnifiedCollectionPreview;

    const assetService = new ImageAssetsService({
        imageHostUrl: ServicesClientImpl.servicesBaseUrls[TIVO_SERVICES.ImageHost],
    });

    let url: string = assetService.getShowcaseBannerImageUrlForTeam(unifiedCollectionId);
    if (unifiedCollectionType === UnifiedCollectionType.LeaguePreview) {
        url = assetService.getShowcaseBannerImageUrlForLeague(unifiedCollectionId);
    }

    return {
        headerContent: <ShowcaseBanner bannerUrl={url} fallbackText={title} size="contain" />,
        headerClassName: 'banner-only',
        bodyContent: (
            <React.Fragment>
                <ContentTitle
                    title={title}
                    postfixTitle={postfixTitle}
                    showType={unifiedCollectionType}
                />
                <ContentDescription description={description} />
            </React.Fragment>
        ),
    };
};
